import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './utils/pwaInstall'; // capture `beforeinstallprompt` before any route renders
import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <AuthProvider>
         <SocketProvider>
    <App />
    </SocketProvider>
  </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
serviceWorkerRegistration.register();
